import { generator, getColor } from './theme.js';

const backgroundColor = (props) => generator({
    props,
    prop: ['backgroundColor', 'bg', 'bgColor'],
    cssProperty: 'backgroundColor',
    getter: getColor,
});

export { backgroundColor };
